/**
 * Transforms a single subject item to the GraphQL node format
 */
export function mapSubjectToNode(item) {
    return {
        id: item.id,
        data: item.data,
        type: item.type,
        ctime: item.ctime,
        utime: item.utime,
        sequence: item.sequence ?? 0,
    };
}
/**
 * Transforms a paginated list of subjects to the GraphQL format
 */
export function mapPaginatedSubjects(result) {
    return {
        totalCount: result?.totalCount ?? 0,
        list: result?.list.map(mapSubjectToNode) ?? [],
    };
}
